import LegalPage from './LegalPage';

// Fuente única de verdad de la Política de Privacidad / Habeas Data (Ley 1581 de 2012).
// Se reutiliza en el HabeasModal para la autorización informada de tratamiento de datos.
export const PRIVACY_SECTIONS = [
  {
    title: '1. Responsable del Tratamiento',
    content: 'New horizont start, con correo de contacto newhorizontstart@gmail.com, es la empresa responsable del tratamiento de sus datos personales, de conformidad con la Ley 1581 de 2012 y el Decreto 1377 de 2013 de la República de Colombia.',
  },
  {
    title: '2. Datos que Recopilamos',
    content: 'Recopilamos únicamente los datos necesarios para la prestación del servicio: nombre de usuario, contraseña cifrada, información de la empresa, datos de contacto asociados a su cuenta y los mensajes intercambiados a través de los canales de WhatsApp conectados a la plataforma.',
  },
  {
    title: '3. Finalidad del Tratamiento',
    content: 'Sus datos personales serán utilizados exclusivamente para: (a) gestionar su acceso a la plataforma, (b) prestar los servicios contratados de automatización vía WhatsApp, (c) enviar comunicaciones relacionadas con el servicio, y (d) cumplir obligaciones legales aplicables.',
  },
  {
    title: '4. Integración con WhatsApp y Meta',
    content: 'La plataforma utiliza la WhatsApp Business Platform de Meta Platforms, Inc. para enviar y recibir mensajes. Para ello, procesamos identificadores de la cuenta de WhatsApp Business (WABA), números de teléfono y el contenido de los mensajes. El tratamiento que Meta realiza de estos datos se rige por las políticas de Meta. Solo solicitamos los permisos estrictamente necesarios para operar el canal de mensajería del cliente.',
  },
  {
    title: '5. Derechos del Titular',
    content: 'Como titular de los datos usted tiene derecho a: conocer, actualizar y rectificar su información personal; solicitar prueba de la autorización otorgada; ser informado sobre el uso de sus datos; presentar quejas ante la Superintendencia de Industria y Comercio; revocar la autorización y solicitar la supresión de sus datos cuando proceda.',
  },
  {
    title: '6. Confidencialidad y Seguridad',
    content: 'New horizont start implementa medidas técnicas y organizativas para proteger su información contra acceso no autorizado, pérdida o alteración. La información propia de cada empresa —los datos de su cuenta, sus usuarios, contactos, conversaciones, pedidos, citas y demás información operativa— es estrictamente confidencial y le pertenece solo a usted: no será vendida, cedida ni compartida con terceros sin su consentimiento expreso, salvo por obligación legal o cuando sea estrictamente necesario para prestar el servicio (por ejemplo, el envío de mensajes a través de Meta o el procesamiento de un pago).',
  },
  {
    title: '7. Difusión de su Catálogo y Noticias',
    content: 'La única información que New horizont start puede mostrar públicamente y difundir es la que usted decide publicar para ofrecer su negocio: sus productos, servicios y precios, así como las noticias y anuncios que publica para sus clientes. Con el fin de darle mayor visibilidad y ayudarle a conseguir nuevos clientes, New horizont start podrá exhibir y promocionar ese contenido comercial en su página web, vitrinas, tienda en línea y canales de difusión. Esta difusión se limita únicamente a dicha información comercial y a sus noticias públicas, y nunca incluye sus datos privados ni los datos personales de sus clientes finales. Si no desea que un producto, servicio o noticia sea visible, basta con no publicarlo o retirarlo de la plataforma.',
  },
  {
    title: '8. Retención de Datos',
    content: 'La plataforma conserva únicamente los últimos 3 meses de conversaciones y mensajes. Los registros con más de 3 meses de antigüedad son eliminados automáticamente de forma permanente. Para conocer cómo solicitar la eliminación de sus datos, consulte nuestra página de Eliminación de Datos.',
  },
  {
    title: '9. Vigencia',
    content: 'La autorización otorgada permanecerá vigente durante el tiempo en que mantenga una cuenta activa en la plataforma y por el período adicional que exija la ley colombiana para efectos de auditoría y cumplimiento normativo.',
  },
  {
    title: '10. Contacto',
    content: 'Para ejercer sus derechos o resolver dudas sobre el tratamiento de sus datos, puede comunicarse con nosotros a newhorizontstart@gmail.com o al celular +57 300 621 4893.',
  },
];

function Privacidad() {
  return (
    <LegalPage
      title="Política de Privacidad"
      subtitle="Ley 1581 de 2012 — Habeas Data · Colombia"
      updatedAt="11 de junio de 2026"
      sections={PRIVACY_SECTIONS}
    />
  );
}

export default Privacidad;
